import selectors from '../../../globals/selectors';
import classNames from '../../../globals/classNames';

export default class {
	constructor(selector) {
		this.element =
			typeof selector === 'string'
				? document.querySelector(selector)
				: selector;
		this.toggleEl = this.element.querySelector(selectors.accordionNew.toggle);
	}

	toggleContentVisibility(isVisible) {
		this.element.classList.toggle(classNames.accordionNew.active, isVisible);
	}

	init({ handleToggleClick }) {
		this.toggleEl.addEventListener('click', handleToggleClick);
	}
}
